<template>
  <div>
    <template v-if="loggedIn">
      <v-app id="inspire" class="app">
        <core-drawer/>
        <core-toolbar/>
        <core-view/>
      </v-app>
    </template>

    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>

    <core-alert/>
  </div>
</template>

<script>
export default {
  name: "app",

  computed: {
    loggedIn() {
      return this.$store.getters.isAuthenticated;
    }
  },

  created() {
    axios.interceptors.response.use(undefined, function(err) {
      return new Promise(function(resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch("logout");
        }
        throw err;
      });
    });
  }
};
</script>

<style lang="scss">
@import "@/styles/index.scss";

.lightbox {
  box-shadow: 0 0 20px inset rgba(0, 0, 0, 0.247);
  background-image: linear-gradient(rgba(0, 0, 0, 0.397) 20%, transparent 100%);
}

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}

/* Extra Styes */
.extra-enter {
  transform: translateX(-200px);
  opacity: 0;
}
.extra-enter-to {
  transform: translateX(0px);
}
.extra-enter-active {
  transition: all 1s cubic-bezier(1, 0.5, 0.8, 1);
}
.extra-leave-active,
.extra-leave-to {
  opacity: 0;
}
</style>
